module.exports = __webpack_public_path__ + "b407139afdd412672276369378268ba1.svg";